import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { IBeverage } from 'app/models/beverage';
import { ISoftUpdate } from 'app/models/softUpdate';
import { ITower } from 'app/models/tower';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class FormComponent implements OnChanges {


  @Input() item!: ITower | null | undefined;
  @Input() uid!: string | null | undefined;
  @Output() softUpdate = new EventEmitter<ISoftUpdate<ITower>>();

  oldContent: ITower | null | undefined;

  form = this.fb.group({
    name: ['', { validators: [Validators.required] }],
    descr: ['',],
  });

  constructor(private fb: FormBuilder) { }

  ngOnChanges(changes: SimpleChanges) {
    if (!!changes['item']?.currentValue) {
      this.oldContent = JSON.parse(JSON.stringify(this.item));

      this.patchFormFromItem(this.item);
    }
  }

  updateDescription() {
    if (this.form.controls.descr.value === this.oldContent?.descr) return;

    if (this.item?.id) {
      const update: Partial<ITower> = {
        descr: this.form.controls.descr.value ?? ''
      };
      this.softUpdateCurrentTower(this.item.id, update);
    }
  }

  updateName() {
    if (this.form.controls.name.value === this.oldContent?.name) return;

    if (this.item?.id) {
      const update: Partial<ITower> = {
        name: this.form.controls.name.value ?? ''
      };
      this.softUpdateCurrentTower(this.item.id, update);
    }
  }


  private softUpdateCurrentTower(locationId: string, item: Partial<ITower>) {
    const update: ISoftUpdate<ITower> = {
      id: locationId,
      data: item,
      uid: this.uid ?? ''
    };
    this.softUpdate.emit(update);

  }


  // #region FORM to ITEM
  private patchFormFromItem(item: ITower | null | undefined) {

    this.form.patchValue({
      name: item?.name,
      descr: item?.descr,
    });
  }
  //#endregion FORM to ITEM


}
